import { format, Locale } from "date-fns";
import { SwimmingLesson } from "../../../../../../models/SwimmingScheduleData";

const toMs = (value: number): number => (value < 1e11 ? value * 1000 : value);

export const formatSwimmingTermLabel = (startTime: number, locale: Locale): string => {
  return format(new Date(toMs(startTime)), "EEEE, dd.MM.yyyy, HH:mm", { locale });
};

export const formatSwimmingLessonTime = (lesson: SwimmingLesson): string => {
  if (lesson.startTime_str) {
    return lesson.closeTime_str ? `${lesson.startTime_str}–${lesson.closeTime_str}` : lesson.startTime_str;
  }
  const start = format(new Date(toMs(lesson.startTime)), "HH:mm");
  if (!lesson.closeTime) {
    return start;
  }
  return `${start}–${format(new Date(toMs(lesson.closeTime)), "HH:mm")}`;
};

/** Krótka etykieta dnia — "pon. 21 września" (bez roku, bez godziny). */
export const formatSwimmingTermDayLabel = (startTime: number, locale: Locale): string => {
  return format(new Date(toMs(startTime)), "EEE d MMMM", { locale });
};

/** Zakres godzin z gołych ms — działa zarówno dla Exercise jak i SwimmingLesson. */
export const formatTimeRange = (startTime: number, closeTime?: number): string => {
  const start = format(new Date(toMs(startTime)), "HH:mm");
  if (!closeTime) {
    return start;
  }
  return `${start}–${format(new Date(toMs(closeTime)), "HH:mm")}`;
};

export default formatSwimmingTermLabel;
